import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { HELPERS } from '../config/constants';
import { updateQuiz } from '../actions/index';

import QuizStats from '../containers/QuizStats';

import '../styles/QuestionNavItem.css';

class QuestionNavItem extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      updateQuiz,
      answered,
      isCorrect,
      viewOnly,
      index,
      selectedIndex,
      scoreCardDisplay,
      visible,
      test,
      finished
    } = this.props;
    const selected = selectedIndex === index;

    return (
      <div
        className={`quiz-nav-item${selected ? ' nav-item-selected' : ''}${
          viewOnly ? ' view-only' : ''
        }${test && !finished ? ' test-hide-stats' : ''}`}
        style={
          visible
            ? {
                color:
                  test && answered && !selected && !finished
                    ? '#D4D4D4'
                    : selected
                      ? answered && (!test || finished)
                        ? isCorrect ? '#94C057' : '#FF7362'
                        : '#727272'
                      : '#727272',
                backgroundColor: selected
                  ? 'white'
                  : answered
                    ? test && !finished
                      ? '#666666'
                      : isCorrect ? '#94C057' : '#FF7362'
                    : '#CECED2'
              }
            : { display: 'none' }
        }
      >
        {!this.props.viewOnly ? (
          <QuizStats
            visible={scoreCardDisplay}
            arrow={index === selectedIndex}
          />
        ) : null}
        <div
          className="nav-div"
          onClick={() => {
            updateQuiz(HELPERS.UPDATE_OBJECT({ currentQuestionIndex: index }));
          }}
        >
          <span>{index + 1}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const question = state.quiz.questions[props.index];

  return {
    answered: question.answered,
    isCorrect:
      question.options[question.selectedOptionIndex] &&
      question.options[question.selectedOptionIndex].correctOption,
    flagged: question.flagged,
    selectedIndex: state.quiz.currentQuestionIndex,
    viewOnly: state.quiz.viewOnly || state.quiz.review,
    test: state.quiz.mode === 1,
    finished:
      state.quiz.questions.reduce(
        (total, question) => total + (question.answered ? 1 : 0),
        0
      ) === state.quiz.questions.length
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateQuiz }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionNavItem);



// WEBPACK FOOTER //
// ./src/containers/QuestionNavItem.js